export const DEPLOYMENT_TIMESTAMP = 'deploymentTimestamp';
